import { OnshapeElement } from '@phi/onshape';
import { ID } from '@phi/newtype';
import { PropType, VNode, defineComponent, h, onMounted, ref } from 'vue';
import { onshapeElementThumbnail } from '@phi/frontend/api/calls';
import { OnshapeLogo } from '@components/icons';
import { img } from '@phi/components';
import { map } from '@vaaas/fpts/result';
import { set } from '@phi/util/vuetils';

const svg_icon = 'img/SVG_icons/files/phi.svg';
const stl_icon = 'img/SVG_icons/files/stl.svg';

export default defineComponent({
    props: {
        value: {
            required: true,
            type: Object as PropType<OnshapeElement>,
        },

        document: {
            required: true,
            type: String as any as PropType<ID<'document'>>,
        },

        workspace: {
            required: true,
            type: String as any as PropType<ID<'workspace'>>,
        },

        fetch: {
            required: false,
            type: Function as PropType<typeof onshapeElementThumbnail>,
            default: onshapeElementThumbnail,
        },
    },

    setup(props) {
        const data_uri = ref(undefined as undefined | string);

        function thumbnail(): VNode {
            if (data_uri.value)
                return h('img', { src: data_uri.value, alt: 'image thumbnail' });
            else switch (props.value.elementType) {
                case 'BLOB':
                    if (props.value.name.endsWith('.phi'))
                        return img(svg_icon);
                    else if (props.value.dataType === 'application/stl')
                        return img(stl_icon);
                    else
                        return OnshapeLogo(false);

                default:
                    return OnshapeLogo(false);
            }
        }

        function should_fetch_thumbnail(x: OnshapeElement) {
            if (x.elementType === 'BLOB') {
                if (x.dataType.startsWith('image/'))
                    return true;
                else
                    return false;
            } else
                return true;
        }

        onMounted(() => {
            if (should_fetch_thumbnail(props.value))
                props.fetch(props.document, props.workspace, props.value.id, '300x300')
                    .then(map(set(data_uri)));
        });

        return () => h('span', { class: 'thumbnail' }, thumbnail());
    },
});
